import type { ComponentProps } from 'react';
import { mergeStyling } from '../common-functions';

export const FieldDescription = ({ className, ...props }: ComponentProps<'p'>) => {
  return <p className={mergeStyling('text-gray-2 text-xs', className)} {...props} />;
};
